module.exports = {
  injectStyle: require('./inject-style'),
  injectStylePrefixed: require('./inject-style-prefixed')
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/styletron-utils/lib/index.js
// module id = 37
// module chunks = 0